
import React from 'react';
import { TranslationContent } from '../types';

interface FooterProps {
  t: TranslationContent['footer'];
}

const Footer: React.FC<FooterProps> = ({ t }) => {
  return (
    <footer className="py-12 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p className="text-sm font-bold text-slate-900 mb-2">
          {t.role}
        </p>
        <p className="text-xs text-slate-600 tracking-wide font-medium">
          &copy; {new Date().getFullYear()} vitornfgoncalves.pt. {t.rights}
        </p>
      </div>
    </footer>
  );
};

export default Footer;